import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import MultiLangText from '../multilang/MultiLangText'

class TransitionScreens extends React.Component {



  componentDidMount(){

      this.props.optionsData.data.menu_items.map((item,i)=>{

        let image = new Image();
        if(window.innerWidth < 1025){
            image.src  =  item.menu_background_active.sizes.large;
        }else{
          image.src = item.menu_background_active.url;
        }
         image.addEventListener('load',()=>{
            //console.log("Image Preloaded");
         })
       })

  }

  render () {
    return (<div id="transitonHolder" className="transition-holder">

    {
      this.props.optionsData.data.menu_items.map((item,i)=>{


        //console.log('item.menu_background',item.menu_background);

        let backgroundActiveImageUrl = (item.menu_background)? item.menu_background_active.url : ''


        if(window.innerWidth < 1025){
          //console.log("Use Smaller TransitionsImage");
          backgroundActiveImageUrl = item.menu_background_active.sizes.large
        }


        let slugClass = item.menu_link.split('/').join('')

            return(
              <div key={"ts"+i} className={"accordion-page "+(slugClass)}>
                 <div className="header">
                <div className="inner-header">
                    <div className="background active" style={{}} >
                        <img src={backgroundActiveImageUrl} alt="" />
                    </div>

                      <div className="text-container">
                        <div className="text-inner">

                            <div className="text" >
                            <div className="line" ref="line1" />
                            <h3 ref="title"><MultiLangText text={item.menu_text_labels} /></h3>
                            <div className="line" ref="line2" />
                            </div>

                        </div>
                      </div>
                    </div>
                </div>
                </div>
              )

            })

            }


            <div id="work-office-fade-bg" />
          </div>
        )
  }
}

const mapStateToProps = (state)=>{
    let pagesData = state.KastnerStore.pagesData, optionsData = state.KastnerStore.optionsData

    return{
      pagesData,
      optionsData
    }
}

export default connect(mapStateToProps)(TransitionScreens);



// WEBPACK FOOTER //
// ./src/modules/transitionscreens/TransitionScreens.js